import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import tokenClient from "api/account/tokenClient";
import { useState, useEffect } from "react";
import {
  parseRolesFromAccessToken,
  REMIT_SUBMIT_ROLE,
  remitRequest,
} from "utils/authUtils";

type RemitRoleState = {
  isRemitUser: boolean;
  isLoading: boolean;
};

const useRemitRole = (): RemitRoleState => {
  const { inProgress } = useMsal();
  const [state, setState] = useState<RemitRoleState>({
    isRemitUser: false,
    isLoading: true,
  });

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    tokenClient
      .getAccessToken(remitRequest)
      .then((accessToken) => {
        const roles = parseRolesFromAccessToken(accessToken);
        setState({
          isRemitUser: roles.includes(REMIT_SUBMIT_ROLE),
          isLoading: false,
        });
      })
      .catch(() => {
        setState({ isRemitUser: false, isLoading: false });
      });
  }, [inProgress]);

  return state;
};

export default useRemitRole;
